import { FC } from 'react';
import Page from 'components/common/Page/Page';

import MonitorsHeader from './MonitorsHeader';
import MonitorsContent from './MonitorsContent';

const Monitors: FC = () => (
  <Page docTitle="Monitors" hasBackground type="full">
    <MonitorsHeader />
    <MonitorsContent />
  </Page>
);

export default Monitors;
